
//Django-related functions for customizing built-in behaviour (like formsets)

function formsetAdd(selector, type) {
    //selector is the last item in the formset, type is forset type that is concatenated into IDs, e.g. criteria_formset
    var $clone = $(selector).clone(true);
    var total = $('#id_' + type + '-TOTAL_FORMS').val();
    $clone.find(':input:not(.formset-delete)').each(function() {
        var name = $(this).attr('name').replace('-' + (total-1) + '-','-' + total + '-');
        var id = 'id_' + name;
        $(this).attr({'name': name, 'id': id}).val('').removeAttr('checked');
    });
    $clone.find('label').each(function() {
        var newFor = $(this).attr('for').replace('-' + (total-1) + '-','-' + total + '-');
        $(this).attr('for', newFor);
    });
    total++;
    $('#id_' + type + '-TOTAL_FORMS').val(total);

    if($clone.find('.formset-delete').length == 0){
        var $button = $('<button type="button" class="button--sm button--full button--primary formset-delete">Remove New Item</button>');
        $button.click(function(){
            formsetRemove(this,type);
        });
        $clone.append($button);
    }
    $(selector).after($clone);
}

function formsetRemove($button, type) {
    $($button).closest(".formset-form").remove();
    var total = $('#id_' + type + '-TOTAL_FORMS').val();
    total--;
    $('#id_' + type + '-TOTAL_FORMS').val(total);
}
